import React, { FC } from 'react';
import styled from 'styled-components';
import constants from '../common/theme/constants';
import KitTips from './KitTips';
import KitIcon from './KitIcon';
import KitButton from './KitButton';

const InfoIcon = styled(KitButton)`
  margin: 0 ${constants.spacing.absolute.xs}px;

  &.circle:hover {
    background-color: inherit;
  }
`;

const ContentWrapper = styled.div`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
`;

export interface KitInfoIconProps {
  ariaLabel: string;
  tooltipContent?: string | React.ReactNode;
  qaId?: string;
}

const KitInfoIcon: FC<KitInfoIconProps> = ({ ariaLabel, tooltipContent, qaId }) => {
  const icon = (
    <InfoIcon data-qa-id={qaId} variant='circle' aria-label={ariaLabel}>
      <KitIcon icon='information-outline' size={`${constants.iconSize.m}rem`} as='span' />
    </InfoIcon>
  );
  if (tooltipContent) {
    return <KitTips content={<ContentWrapper>{tooltipContent}</ContentWrapper>}>{icon}</KitTips>;
  }
  return <>{icon}</>;
};

export default KitInfoIcon;
